import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, resource, signal } from '@angular/core';
import { ClarityModule } from '@clr/angular';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';
import { TransformColNamesPipe } from '../../_overlays/zaehlerverwaltung/transform-col-names.pipe';
import { ImageSlideShowComponent } from '../../_shared/media-slide-show/image-slide-show.component';
import { AusfallColorPipe } from '../zaehlertab/ausfall-color.pipe';
import { Table } from 'src/app/models/ui/table';
import { MessungÜbersicht } from '../../_overlays/zaehlerverwaltung/zaehler.types';
import { ZaehlerApiService } from 'src/app/services/APIService/zaehler.api.service';
import { MessungVergleichComponent } from '../../_modals/messung-vergleich/messung-vergleich.component';
import { ifNotError } from 'src/app/misc/compositions';

@Component({
  selector: 'app-messung-grid',
  templateUrl: './messung-grid.component.html',
  styleUrl: './messung-grid.component.scss',
  imports: [
    CommonModule,
    ClarityModule,
    TransformColNamesPipe,
    AusfallColorPipe,
    MrTranslatePipe,
    TablePrettyPrintPipe,
    HideIDColumnsPipe,
    ImageSlideShowComponent,
    MessungVergleichComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessungGridComponent {
  private readonly api = inject(ZaehlerApiService);
  protected readonly tol = this.api.getToleranzenBezeichnungen();

  protected readonly name = input.required<string>();
  protected readonly ersterEintragMessung = input<string | undefined>();
  protected readonly OPRUEFID = input.required<number>();

  private readonly skizzeRs = resource({
    params: () => {
      const opruefid = this.OPRUEFID();
      const name = this.name();
      if (!name) return undefined;
      return { opruefid, name };
    },
    loader: ({ params: { opruefid, name } }) => this.api.getSkizzeWithAusfallPoints(opruefid, name),
  });

  protected readonly skizze = ifNotError<string>(this.skizzeRs);
  protected readonly messungen = input.required<Table<MessungÜbersicht>>();

  protected readonly selectedRow = signal<MessungÜbersicht>(undefined);
}
